// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBv0EO98rhBvdp1RpRNng4xfX9wPSHDGxU",
    authDomain: "gyc-plaza.firebaseapp.com",
    databaseURL: "https://gyc-plaza.firebaseio.com",
    projectId: "gyc-plaza",
    storageBucket: "gyc-plaza.appspot.com",
    messagingSenderId: "91311323715"
  }
};



// WEBPACK FOOTER //
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/environments/environment.ts